import { useEffect, useRef } from 'react'
import gsap from 'gsap'

const featuredInLogo = '/assets/featured-in-logo.png'

// ─── Inline app preview mockup ────────────────────────────────────────────────

function AppPreviewMockup() {
  const competencies = [
    { label: 'Leadership', pct: 82, color: '#359d9e' },
    { label: 'Communication', pct: 74, color: '#27777a' },
    { label: 'Problem Solving', pct: 90, color: '#359d9e' },
    { label: 'Collaboration', pct: 68, color: '#27777a' },
  ]

  const navItems = [
    { label: 'Dashboard', active: false },
    { label: 'Kinerja', active: true },
    { label: 'Wawasan', active: false },
    { label: 'Rekrut', active: false },
  ]

  return (
    <div className="relative w-full h-full select-none">
      {/* Main browser chrome */}
      <div
        className="absolute rounded-xl overflow-hidden shadow-[0px_4px_32px_0px_rgba(53,157,158,0.18)] bg-white border border-[rgba(53,157,158,0.12)]"
        style={{ top: '10%', left: '4%', right: '10%', bottom: '8%' }}
      >
        {/* Title bar */}
        <div className="flex items-center gap-1.5 px-3 py-2 bg-[#f8fffe] border-b border-[rgba(53,157,158,0.1)]">
          <div className="w-2.5 h-2.5 rounded-full bg-[#ff5f57]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#febc2e]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#28c840]" />
          <div className="flex-1 mx-3 h-4 rounded bg-[#e6e7e7] text-[9px] text-[#b3b7b7] flex items-center px-2">
            pelajari.ai/kinerja
          </div>
        </div>

        {/* App layout */}
        <div className="flex h-full">
          {/* Sidebar */}
          <div className="w-[28%] border-r border-[rgba(53,157,158,0.08)] bg-[#fafffe] flex flex-col py-3 gap-0.5 px-2 flex-shrink-0">
            <div className="flex items-center gap-1.5 px-1.5 pb-2 mb-1 border-b border-[rgba(53,157,158,0.08)]">
              <div className="w-4 h-4 rounded bg-[#359d9e] flex items-center justify-center flex-shrink-0">
                <svg viewBox="0 0 10 10" className="w-2.5 h-2.5" fill="white">
                  <circle cx="5" cy="5" r="3.5" fill="none" stroke="white" strokeWidth="1.5" />
                  <circle cx="5" cy="5" r="1" fill="white" />
                </svg>
              </div>
              <span className="text-[9px] font-bold text-[#1a2727] tracking-tight">Pelajari</span>
            </div>
            {navItems.map((item) => (
              <div
                key={item.label}
                className={`px-2 py-1 rounded text-[9px] font-medium ${
                  item.active ? 'bg-[#359d9e] text-white' : 'text-[#b3b7b7]'
                }`}
              >
                {item.label}
              </div>
            ))}
          </div>

          {/* Main content */}
          <div className="flex-1 p-3 overflow-hidden flex flex-col gap-2.5 bg-[#f8fffe]">
            <div>
              <p className="text-[9px] text-[#b3b7b7]">Welcome back,</p>
              <p className="text-[11px] font-bold text-[#1a2727] leading-tight">Hana Pertiwi 👋</p>
            </div>
            <div className="bg-white rounded-lg border border-[rgba(53,157,158,0.1)] p-2.5 flex items-center gap-2">
              <div className="w-7 h-7 rounded-full bg-[#f2fbfa] border-2 border-[#359d9e]/20 flex items-center justify-center flex-shrink-0 text-[10px] font-bold text-[#359d9e]">
                HP
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[9px] font-semibold text-[#1a2727] truncate">Hana Pertiwi</p>
                <p className="text-[8px] text-[#b3b7b7] truncate">Software Engineer II</p>
              </div>
              <div className="bg-[#f2fbfa] border border-[#d5f2ef] text-[#27777a] text-[8px] font-semibold px-1.5 py-0.5 rounded-full flex-shrink-0">
                High Potential
              </div>
            </div>
            <div className="bg-white rounded-lg border border-[rgba(53,157,158,0.1)] p-2.5 flex flex-col gap-1.5">
              <p className="text-[8px] font-bold text-[#b3b7b7] uppercase tracking-wider">Competency Scores</p>
              {competencies.map((c) => (
                <div key={c.label} className="flex items-center gap-1.5">
                  <span className="text-[8px] text-[#1a2727] w-[56px] flex-shrink-0 truncate">{c.label}</span>
                  <div className="flex-1 h-1.5 bg-[#e6e7e7] rounded-full overflow-hidden">
                    <div className="h-1.5 rounded-full" style={{ width: `${c.pct}%`, backgroundColor: c.color }} />
                  </div>
                  <span className="text-[8px] font-semibold w-6 text-right flex-shrink-0" style={{ color: c.color }}>
                    {c.pct}
                  </span>
                </div>
              ))}
            </div>
            <div className="bg-white rounded-lg border border-[rgba(53,157,158,0.1)] p-2 flex items-center gap-2">
              <div className="w-5 h-5 flex-shrink-0">
                <svg viewBox="0 0 20 20" className="w-full h-full -rotate-90">
                  <circle cx="10" cy="10" r="7" fill="none" stroke="#e6e7e7" strokeWidth="3" />
                  <circle cx="10" cy="10" r="7" fill="none" stroke="#359d9e" strokeWidth="3"
                    strokeDasharray={`${0.82 * 44} 44`} strokeLinecap="round" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[8px] font-semibold text-[#1a2727] truncate">Q1 Performance Review</p>
                <p className="text-[8px] text-[#b3b7b7]">82% complete</p>
              </div>
              <div className="bg-[#fff7ed] text-[#fc8213] text-[7px] font-semibold px-1.5 py-0.5 rounded-full flex-shrink-0">
                In Progress
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating card — top right: AI Insight */}
      <div
        className="hero-float-card-1 absolute bg-white rounded-xl border border-[rgba(53,157,158,0.15)] shadow-[0px_4px_20px_0px_rgba(53,157,158,0.18)] p-3 flex flex-col gap-1.5"
        style={{ top: '2%', right: '0%', width: '38%' }}
      >
        <div className="flex items-center gap-1.5">
          <div className="w-4 h-4 rounded-md bg-[#f2fbfa] flex items-center justify-center flex-shrink-0">
            <svg viewBox="0 0 12 12" className="w-2.5 h-2.5" fill="none">
              <path d="M6 1L7.5 4.5H11L8 6.5L9 10L6 8L3 10L4 6.5L1 4.5H4.5L6 1Z" fill="#359d9e" />
            </svg>
          </div>
          <span className="text-[9px] font-semibold text-[#1a2727]">AI Insight</span>
        </div>
        <p className="text-[8px] text-[#1a2727] leading-relaxed">
          Hana scores in the <span className="font-semibold text-[#359d9e]">top 15%</span> for Problem Solving across the engineering team.
        </p>
      </div>

      {/* Floating card — bottom left: Pending Reviews */}
      <div
        className="hero-float-card-2 absolute bg-white rounded-xl border border-[rgba(53,157,158,0.15)] shadow-[0px_4px_20px_0px_rgba(53,157,158,0.18)] p-2.5 flex items-center gap-2"
        style={{ bottom: '2%', left: '0%', width: '42%' }}
      >
        <div className="w-7 h-7 rounded-lg bg-[#fff7ed] flex items-center justify-center flex-shrink-0">
          <svg viewBox="0 0 14 14" className="w-4 h-4" fill="none">
            <rect x="2" y="1" width="10" height="12" rx="1.5" stroke="#fc8213" strokeWidth="1.2" />
            <path d="M4.5 5H9.5M4.5 7.5H8M4.5 10H7" stroke="#fc8213" strokeWidth="1" strokeLinecap="round" />
          </svg>
        </div>
        <div>
          <p className="text-[9px] font-bold text-[#1a2727]">3 Pending Reviews</p>
          <p className="text-[8px] text-[#b3b7b7]">Due this week</p>
        </div>
      </div>
    </div>
  )
}

// ─── Main Hero ────────────────────────────────────────────────────────────────

export function LandingHero() {
  const sectionRef = useRef<HTMLElement>(null)
  const headingRef = useRef<HTMLHeadingElement>(null)
  const subRef = useRef<HTMLParagraphElement>(null)
  const ctaRef = useRef<HTMLDivElement>(null)
  const featuredRef = useRef<HTMLDivElement>(null)
  const mockupRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

      // Set initial hidden states
      gsap.set([headingRef.current, subRef.current, ctaRef.current, featuredRef.current], {
        opacity: 0, y: 32,
      })
      gsap.set(mockupRef.current, { opacity: 0, x: 52 })

      // Entrance sequence
      tl.to(headingRef.current, { opacity: 1, y: 0, duration: 0.75 })
        .to(subRef.current, { opacity: 1, y: 0, duration: 0.6 }, '-=0.45')
        .to(ctaRef.current, { opacity: 1, y: 0, duration: 0.55 }, '-=0.35')
        .to(featuredRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.25')
        .to(mockupRef.current, { opacity: 1, x: 0, duration: 0.85, ease: 'power2.out' }, 0.15)

      // Idle float — fires after entrance completes
      tl.add(() => {
        // Main mockup
        gsap.to(mockupRef.current, {
          y: -10, duration: 3.2, ease: 'sine.inOut',
          yoyo: true, repeat: -1,
        })
        // Floating card 1 (AI Insight) — offset phase
        gsap.to('.hero-float-card-1', {
          y: -6, duration: 2.8, ease: 'sine.inOut',
          yoyo: true, repeat: -1, delay: 0.5,
        })
        // Floating card 2 (Pending Reviews) — offset phase
        gsap.to('.hero-float-card-2', {
          y: -8, duration: 3.5, ease: 'sine.inOut',
          yoyo: true, repeat: -1, delay: 1.1,
        })
      })
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={sectionRef}
      className="flex flex-col items-center justify-center gap-10 px-6 py-16 md:px-10 lg:flex-row lg:gap-12 lg:px-[120px] max-w-screen-xl mx-auto"
    >
      {/* Left Content */}
      <div className="flex flex-col gap-10 w-full lg:w-[588px] relative text-center lg:text-left">
        <div className="flex flex-col gap-6">
          <h1
            ref={headingRef}
            className="text-[36px] font-semibold leading-[44px] tracking-[-1px] text-[#000f0f] sm:text-[48px] sm:leading-[58px] lg:text-[60px] lg:leading-[72px] lg:tracking-[-1.5px]"
          >
            Leverage{' '}
            <span className="inline-block bg-[#359d9e] text-white px-3 py-1 rounded-lg align-middle">
              AI
            </span>
            {' '}to grow your human capital
          </h1>
          <p ref={subRef} className="text-base leading-relaxed text-[#000f0f]">
            From{' '}
            <span className="font-semibold text-[#359d9e]">performance reviews</span>
            {' '}to{' '}
            <span className="font-semibold text-[#359d9e]">psychometric assessments</span>
            , talent intelligence to{' '}
            <span className="font-semibold text-[#359d9e]">smart hiring</span>
            {' '}— Pelajari unifies your entire HR stack with AI at its core.
          </p>
        </div>

        <div ref={ctaRef} className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center lg:justify-start sm:gap-5">
          <a
            href="/#book-demo"
            className="bg-[#359d9e] text-white hover:bg-[#27777a] rounded px-5 py-2.5 font-medium capitalize w-full sm:w-auto text-center transition-colors"
          >
            Book a Demo
          </a>
          <a
            href="/#how-it-works"
            className="text-[#359d9e] hover:text-[#27777a] px-5 py-2.5 font-medium capitalize inline-flex items-center gap-2 w-full sm:w-auto justify-center transition-colors"
          >
            Learn More <span className="text-lg">→</span>
          </a>
        </div>

        <div ref={featuredRef} className="flex flex-col gap-3 w-full max-w-[225px] mx-auto lg:mx-0">
          <p className="text-base text-[#000f0f]">Featured in</p>
          <img
            src={featuredInLogo}
            alt="UI Incubate"
            className="w-full h-auto max-h-10 object-contain object-left"
          />
        </div>
      </div>

      {/* Right Content — App Preview */}
      <div
        ref={mockupRef}
        className="relative w-full max-w-[520px] h-[340px] sm:h-[420px] lg:w-[560px] lg:h-[460px] mx-auto flex-shrink-0"
      >
        <AppPreviewMockup />
      </div>
    </section>
  )
}
